import { apiClient } from './api'

/**
 * Sprint 29 — self-serve password reset.
 *
 * Both endpoints are public. `requestReset` always resolves on 202 — the
 * backend deliberately returns the same response whether or not the email
 * exists (no account enumeration), so the UI must not branch on it either.
 */
export const passwordResetService = {
  requestReset: async (email: string): Promise<void> => {
    await apiClient.post('/api/v1/auth/forgot-password', { email })
  },

  resetPassword: async (token: string, newPassword: string): Promise<void> => {
    await apiClient.post('/api/v1/auth/reset-password', {
      token,
      new_password: newPassword,
    })
  },
}
